import React from 'react'

export const AccountsCreationModal = ({ open, setModal }) => {
  return (
    <>
      <div
        className={` ${
          !open && 'hidden'
        } absolute text-[12px] left-[-8px] bottom-[-60px] md:w-[917px] bg-[#37A2BA] text-white border-[#EBFBFF] border-[1px] shadow-[0px_0px_14px_0px_rgba(0,0,0,0.25)] rounded-[10px]`}
      >
        <ul className='p-[15px_14px] space-y-[10px] list-disc '>
          <li className='ml-[10px] '>
            Law firm: if you are an entity regulated by the Solicitors
            Regulation Authority, and included within the SRA Register, and
            seeking to create an account on behalf of this entity (including the
            management of any associated solicitor profiles) as an account
            manager, you should use this account type. This account type is not
            for the management of an individual solicitor profile.
          </li>
          <li className='ml-[10px] '>
            Chambers: if you are an entity regulated by the Bar Standards Board,
            and included within the BSB Entities Register, and seeking to create
            an account on behalf of this entity (including the management of any
            associated barrister profiles) as an account manager, you should use
            this account type. This account type is not for the management of an
            individual barrister profile.
          </li>
          <li className='ml-[10px] '>
            Solicitor: if you are an individual solicitor regulated by the
            Solicitors Regulation Authority, and included within the SRA
            Register, and seeking to manage your individual solicitor profile,
            you should use this account type.
          </li>
          <li className='ml-[10px] '>
            Barrister: if you are an individual barrister regulated by the Bar
            Standards Board, and included within the BSB Register, and seeking
            to manage your individual barrister profile, you should use this
            account type.
          </li>
        </ul>
      </div>
    </>
  )
}
